<template>
  <div>
    <div class="font-14 f-regular text-start mar-top-16 text-gray">
      {{ label }} <span class="text-blue">*</span>
    </div>

    <div class="card" @click="goKeTrainingJadwal(idjenis)">
      <div class="row remove-margin card-detail">
        <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
          <div class="font-14 text-name color-6f7">Jadwal Training</div>
          <div class="text-name f-18 f-bold">
            {{ displayTextSesi }}
          </div>
        </div>
        <div
          class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M15.3998 10.3801L10.8098 5.79006C10.6224 5.60381 10.369 5.49927 10.1048 5.49927C9.84062 5.49927 9.58716 5.60381 9.3998 5.79006C9.30607 5.88302 9.23168 5.99362 9.18091 6.11548C9.13014 6.23734 9.104 6.36805 9.104 6.50006C9.104 6.63207 9.13014 6.76278 9.18091 6.88464C9.23168 7.0065 9.30607 7.1171 9.3998 7.21006L13.9998 11.7901C14.0935 11.883 14.1679 11.9936 14.2187 12.1155C14.2695 12.2373 14.2956 12.368 14.2956 12.5001C14.2956 12.6321 14.2695 12.7628 14.2187 12.8846C14.1679 13.0065 14.0935 13.1171 13.9998 13.2101L9.3998 17.7901C9.2115 17.977 9.10518 18.2312 9.10425 18.4965C9.10331 18.7619 9.20783 19.0168 9.3948 19.2051C9.58178 19.3934 9.8359 19.4997 10.1013 19.5006C10.3666 19.5016 10.6215 19.397 10.8098 19.2101L15.3998 14.6201C15.9616 14.0576 16.2772 13.2951 16.2772 12.5001C16.2772 11.7051 15.9616 10.9426 15.3998 10.3801Z"
              fill="#595959"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "FormInputJadwal",
  props: {
    label: "",
    idjenis: "",
    sesi: 0,
  },
  computed: {
    ...mapGetters(moduleName, {
      formJadwal: "formJadwal",
      jadwalDirection: "jadwalDirection",
    }),
    displayTextSesi() {
      const jadwalMulai =
        this.formJadwal.jadwal_training[this.sesi - 1].jadwal_mulai;
      const jadwalSelesai =
        this.formJadwal.jadwal_training[this.sesi - 1].jadwal_selesai;

      if (jadwalMulai !== "" && jadwalSelesai !== "") {
        const formattedMulai =
          this.$moment(jadwalMulai).format("DD MMMM YYYY HH:mm");
        const formattedSelesai = this.$moment(jadwalSelesai).format("HH:mm");
        return `${formattedMulai} - ${formattedSelesai}`;
      } else {
        return "Belum Dipilih";
      }
    },
  },
  methods: {
    goKeTrainingJadwal(param_idjenis) {
      let index = this.sesi - 1;
      if (this.formJadwal.jadwal_training[this.sesi + 1] != "") {
        if (this.sesi == 1) {
          this.jadwalDirection.afterChoose =
            this.formJadwal.jadwal_training[0].jadwal_mulai;
          this.jadwalDirection.rangeOnDate =
            this.formJadwal.jadwal_training[1].jadwal_mulai;
        }
      }
      if (this.formJadwal.jadwal_training[this.sesi - 1] != "") {
        if (this.sesi == 2) {
          this.jadwalDirection.afterChoose =
            this.formJadwal.jadwal_training[1].jadwal_mulai;
          this.jadwalDirection.rangeOnDate =
            this.formJadwal.jadwal_training[0].jadwal_mulai;
        }
      }
      this.$router.push({
        name: "training.pilihJadwal",
        params: { idjenis: param_idjenis, sesi: this.sesi },
      });
    },
  },
};
</script>

<style scoped>
.belajar-bersama-smartlink .separator {
  width: unset;
}
.d-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.text-container {
  display: flex;
}

.text-container .epayment-container {
  width: 121px;
}
.text-container .reminder-container {
  width: 71px;
}

.card {
  padding: 16px;
}
.text-blue {
  color: #206cff;
}

.text-gray {
  color: #6f7287;
}

.divider-line {
  display: flex;
  width: 320px;
  height: 4px;
  padding: 2px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.icon-container {
  align-items: end;
}

.btnlnjt {
  margin-top: 7rem;
  background-color: #206cff;
  color: white;
}

.btn-disabled {
  background-color: #ccc;
  color: #f6f6f6;
}
</style>
